(function(jQuery, undefined) {
    var sm = (window.sm = window.sm || {});
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /************************************************/
    /* Academic Details View Model                  */
    /************************************************/
    function AcademicDetailsViewModel() {
        var self = this;

        this.AcademicLevels = ko.observableArray();
        this.Goals = ko.observableArray();
        this.AdmissionsProgramsOne = ko.observableArray();
        this.AdmissionsProgramsTwo = ko.observableArray();
        this.AdmissionsProgramsThree = ko.observableArray();
        this.DeliveryMethods = ko.observableArray();
        this.Campuses = ko.observableArray();
        this.AdmissionsOfferingItems = ko.observableArray();
        this.LevelsOfStudy = ko.observableArray();
        this.AcademicPeriods = ko.observableArray();

        this.CampusID = ko.validatedObservable();
        this.AcademicLevelID = ko.validatedObservable();
        this.LevelOfStudyID = ko.validatedObservable();
        this.LevelOfStudyEnabled = ko.observable(false);
        this.DeliveryMethodID = ko.validatedObservable();
        this.AdmissionsProgramIDOne = ko.validatedObservable();
        this.AdmissionsProgramIDTwo = ko.validatedObservable();
        this.AdmissionsProgramIDThree = ko.validatedObservable();
        this.ExpectedStartPeriodID = ko.validatedObservable();
        this.ExpectedEntrancePeriodRequired = ko.observable(false);

        this.SetAvailableOptions = function(options, entity) {

            if (entity)
            {
                this.CampusID(entity.CampusID);
                this.AcademicLevelID(entity.AcademicLevelID);
                this.LevelOfStudyID(entity.LevelOfStudyID);
                this.DeliveryMethodID(entity.DeliveryMethodID);
                this.AdmissionsProgramIDOne(entity.AdmissionsProgramIDOne);
                this.AdmissionsProgramIDTwo(entity.AdmissionsProgramIDTwo);
                this.AdmissionsProgramIDThree(entity.AdmissionsProgramIDThree);
                this.ExpectedStartPeriodID(entity.ExpectedStartPeriodID);
            }

            this.AcademicLevels(smapi.access.loadListItemModels(options.AcademicLevels, [], true));
            this.Goals(smapi.access.loadListItemModels(options.ApplicationGoals, [], true));
            this.AdmissionsProgramsOne(smapi.access.loadListItemModels(options.AdmissionsPrograms.filter(function (x) { return x.Value !== self.AdmissionsProgramIDTwo() && x.Value !== self.AdmissionsProgramIDThree(); }), [], true));
            this.AdmissionsProgramsTwo(smapi.access.loadListItemModels(options.AdmissionsPrograms.filter(function (x) { return x.Value !== self.AdmissionsProgramIDOne() && x.Value !== self.AdmissionsProgramIDThree(); }), [], true));
            this.AdmissionsProgramsThree(smapi.access.loadListItemModels(options.AdmissionsPrograms.filter(function (x) { return x.Value !== self.AdmissionsProgramIDOne() && x.Value !== self.AdmissionsProgramIDTwo(); }), [], true));
            this.DeliveryMethods(smapi.access.loadListItemModels(options.DeliveryMethods, [], true));
            this.Campuses(smapi.access.loadListItemModels(options.Campuses, [], true));
            this.AdmissionsOfferingItems(smapi.access.loadListItemModels(options.AdmissionsProgramOfferingItems, [], true));
            this.LevelsOfStudy(smapi.access.loadListItemModels(options.LevelsOfStudy.sort(function (l, r) { return l.Sequence - r.Sequence; }), []));
            this.AcademicPeriods(smapi.access.loadListItemModels(options.ExpectedStartPeriods, [], true));
        };

        this.ForceNoModified = function() {
            this.CampusID.isModified(false);
            this.AcademicLevelID.isModified(false);
            this.LevelOfStudyID.isModified(false);
            this.DeliveryMethodID.isModified(false);
            this.AdmissionsProgramIDOne.isModified(false);
            this.AdmissionsProgramIDTwo.isModified(false);
            this.AdmissionsProgramIDThree.isModified(false);
            this.ExpectedStartPeriodID.isModified(false);
        };

        this.SelectedAdmissionPrograms = function() {
            return [this.AdmissionsProgramIDOne(), this.AdmissionsProgramIDTwo(), this.AdmissionsProgramIDThree()];
        };

        this.CampusID.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicLevelID.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.LevelOfStudyID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            required: {
                onlyIf: self.LevelOfStudyEnabled,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.AdmissionsProgramIDOne.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue('OneProgramRequired'),
                onlyIf: function() {
                    return sm.portal.utility.isNullOrEmpty(self.AdmissionsProgramIDTwo()) && sm.portal.utility.isNullOrEmpty(self.AdmissionsProgramIDThree());
                }
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsProgramIDTwo.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionsProgramIDThree.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DeliveryMethodID.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key),
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExpectedStartPeriodID.extend({
            required: {
                onlyIf: self.ExpectedEntrancePeriodRequired,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
		
        this.ModelErrors = ko.validation.group(this);
		
        this.IsVMValid = function () {
            var o = this.ModelErrors().length == 0;
            return o;

        };

        return self;
    }

    jQuery.extend(true, sm.portal.vm, {
        AcademicDetailsViewModel: AcademicDetailsViewModel
    });
})(jQuery);
